import { render, staticRenderFns } from "./SystemSettingsIndex.vue?vue&type=template&id=4e6873a7&scoped=true&"
import script from "./SystemSettingsIndex.vue?vue&type=script&lang=js&"
export * from "./SystemSettingsIndex.vue?vue&type=script&lang=js&"
import style0 from "./SystemSettingsIndex.vue?vue&type=style&index=0&id=4e6873a7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6873a7",
  null
  
)

export default component.exports